module.exports = __webpack_public_path__ + "arrowDropdown-2bt--nd.svg";